<div class="p-grid p-align-center p-justify-even headerContainer blueColor" [ngClass]="{'header-shadow' : showHeaderShadow}">

  <div class="mobile-header p-sm-2 p-md-1 p-lg-1 p-xl-1 logoCol">
    <a routerLink="/">
      <img src="assets/logo.png" alt="nuty.eu" class="logo-img">
    </a>
  </div>

  <div class="p-sm-0 p-md-0 p-lg-4 p-xl-5 show-links">
    <div class="p-grid p-align-center">      
      <div style="margin-left: 10px;"><a routerLink="/" class="blueColorHover"><i class="pi pi-home iconMenu"></i> {{ 'main_page' | translate }}</a></div>
      <div style="margin-left: 10px;"><a routerLink="/onas" class="blueColorHover"><i class="pi pi-info iconMenu"></i> {{ 'about_us' | translate }}</a></div>
      <div style="margin-left: 10px;"><a routerLink="/zasugeruj" class="blueColorHover"><i class="pi pi-question-circle iconMenu"></i> {{ 'suggest_song_header' | translate }}</a></div>
      <div style="margin-left: 10px;"><a routerLink="/kontakt" class="blueColorHover"><i class="pi pi-envelope iconMenu"></i> {{ 'contact' | translate }}</a></div>

      <div mat-button [matMenuTriggerFor]="menu"  style="margin-left: 10px;"><a class="blueColorHover"><i class="pi pi-list iconMenu"></i> {{ 'search_categories' | translate }}</a>
        <mat-menu #menu="matMenu" class="categoriesMenu">
          <button *ngFor="let item of categoriesItems" mat-menu-item (click)="handlecategoryItemClick(item)" class="categoryItem">{{ item.name }}</button>
        </mat-menu>
      </div>
    </div>
  </div>

  <div class="p-sm-5 p-md-6 p-lg-3 p-xl-2 show-register">
    <div class="p-grid p-justify-end p-align-center">
      <div *ngIf="!isLogin" style="margin-right: 15px;"><a routerLink="/register" class="blueColorHover">{{ 'register' | translate }}</a></div>
      <div *ngIf="!isLogin"><a routerLink="/login" class="blueColorHover">{{ 'login' | translate }}</a></div>
      <div *ngIf="isLogin"> 
        <button pButton type="button" icon="pi pi-user" label="{{ 'my_account' | translate }} ({{loginDisplay}})" (click)="user_menu.toggle($event)" class="blank-button"></button>
        <p-menu #user_menu [popup]="true" [model]="userMenu" styleClass="user-menu" appendTo="body"></p-menu>
      </div> 
    </div>
  </div>

  <div class="mobile-header p-sm-0 p-md-0 p-lg-0 p-xl-0 show-response-user">
    <div class="p-grid p-justify-center p-align-center">
      <button pButton type="button" (click)="response_user_menu.toggle($event)" class="blank-button">
        <i class="pi pi-user" style="font-size: 40px; margin-top: 4px;"></i>
      </button>
      <p-menu #response_user_menu [popup]="true" [model]="userMenu" styleClass="user-menu" appendTo="body"></p-menu>
    </div>
  </div>

  <div class="p-sm-1 p-md-1 p-lg-1 p-xl-1 show-lang">
    <div class="p-grid p-justify-center">
      <p-menu #lang_menu [popup]="true" [model]="langs" styleClass="lang-menu" appendTo="body"></p-menu>
      <div (click)="lang_menu.toggle($event)" class="menu-selector">
        <span style="font-size: 12px; display: block;">
          {{ 'language' | translate }}
        </span>
        <span style="font-weight: bold;">
          {{ selectedLang | uppercase }}
        </span>
      </div>
    </div>
  </div>

  <div class="p-sm-1 p-md-1 p-lg-1 p-xl-1 show-lang">
    <div class="p-grid  p-justify-center">
      <p-menu #currency_menu [popup]="true" [model]="currencies" styleClass="currency-menu" appendTo="body"></p-menu>
      <div (click)="currency_menu.toggle($event)" class="menu-selector">
        <span style="font-size: 12px; display: block;">
          {{ 'currency' | translate }} 
        </span>
        <span style="font-weight: bold;">
          {{ selectedCurrency }}
        </span>
      </div>
    </div>
  </div>

  <div class="mobile-header p-sm-1 p-md-1 p-lg-2 p-xl-2 cartCol"> 
    <a routerLink="/koszyk" class="p-grid  p-justify-even p-align-center blueColorHover">
      <!-- <span class="hide-on-narrow">{{ 'shopping-cart' | translate }}</span> -->
      <div  style="position:relative">
        <div *ngIf="counterCart !== 0" style="position: absolute;
        right: 0px;
        top: 5px;
        height: 23px;
        width: 23px;
        background-color: #fff;
        z-index: 99999999;
        border-radius: 50%;
        border: 1px solid #40499b;
        display: flex;
        justify-content: center;"><span style="    font-size: 12px;
    display: flex;
    align-items: center;" >{{counterCart}}</span></div>
        <i class="pi pi-shopping-cart"></i></div>
    </a>
  </div>

  <div class="mobile-header p-sm-1 p-md-1 p-lg-0 p-xl-0 p-justify-center" style="text-align: center;"> 
    <div class="narrow-menu">
      <button pButton type="button" (click)="narrow_menu.toggle($event)" class="blank-button">
        <i class="pi pi-bars" style="font-size: 40px; margin-top: 4px;"></i>
      </button>
      <p-menu #narrow_menu [popup]="true" [model]="narrowWidthMenu" appendTo="body" styleClass="menu-narrow"></p-menu>
    </div>    
  </div>
</div>

<div id="back-to-top-button" (click)="onScrollToTop()">
  <i class="pi pi-chevron-up"></i>
</div>

<p-dialog [(visible)]="displayLanguageDialog" [style]="{'width': '100%', 'max-width': '320px'}">
  <p-header>
    {{ 'select_language' | translate }}
  </p-header>
  <div style="text-align: center;" class="switcher-dialog">
    <div [ngClass]="{ 'selected-item' : selectedLang == 'pl' }" (click)="switchLang('pl')">
      <p [ngClass]="{ 'selected-item-font' : selectedLang == 'pl' }">Polski</p>
    </div>
    <div [ngClass]="{ 'selected-item' : selectedLang == 'en' }" (click)="switchLang('en')">
      <p [ngClass]="{ 'selected-item-font' : selectedLang == 'en' }">English</p>
    </div>
    <div [ngClass]="{ 'selected-item' : selectedLang == 'de' }" (click)="switchLang('de')">
      <p [ngClass]="{ 'selected-item-font' : selectedLang == 'de' }">Deutsch</p>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayLanguageDialog=false" label="{{ 'close_btn' | translate }}"></button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="displayCurrencyDialog" [style]="{'width': '100%', 'max-width': '320px'}">
  <p-header>
    {{ 'select_currency' | translate }}
  </p-header>
  <div style="text-align: center;" class="switcher-dialog">
    <div [ngClass]="{ 'selected-item' : selectedCurrency == 'PLN' }" (click)="switchCurrency('PLN')">
      <p [ngClass]="{ 'selected-item-font' : selectedCurrency == 'PLN' }">PLN</p>
    </div>
    <div [ngClass]="{ 'selected-item' : selectedCurrency == 'EUR' }" (click)="switchCurrency('EUR')">
      <p [ngClass]="{ 'selected-item-font' : selectedCurrency == 'EUR' }">EUR</p>
    </div>
    <div [ngClass]="{ 'selected-item' : selectedCurrency == 'USD' }" (click)="switchCurrency('USD')">
      <p [ngClass]="{ 'selected-item-font' : selectedCurrency == 'USD' }">USD</p>
    </div>
    <div [ngClass]="{ 'selected-item' : selectedCurrency == 'GBP' }" (click)="switchCurrency('GBP')">
      <p [ngClass]="{ 'selected-item-font' : selectedCurrency == 'GBP' }">GBP</p>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayCurrencyDialog=false" label="{{ 'close_btn' | translate }}"></button>
  </p-footer>
</p-dialog>

